import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
    return (
        <Container className="text-center" style={{ fontFamily: 'Arial', backgroundColor: '#f8f8f8', color: '#333', height: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0 1rem' }}>
            <Row>
                <Col>
                    <h1 style={{ fontSize: '8em', margin: '0', color: '#e74c3c' }}>404</h1>
                    <p style={{ fontSize: '1.5em', margin: '0', color: '#777' }}>Oops! Looks like you're lost.</p>
                    <p style={{ fontSize: '1.5em', margin: '0', color: '#777' }}>The page you are looking for might have been removed or never existed.</p>
                    <p style={{ fontSize: '1.5em', margin: '0', color: '#777' }}>Let's get you back <Link to="/" style={{ color: '#3498db', textDecoration: 'none', fontWeight: 'bold' }}>home</Link>.</p>
                </Col>
            </Row>
        </Container>
    );
}

export default NotFoundPage;
